// @flow
const OPTIONS: 'options' = 'options';
const ZONES: 'zones' = 'zones';
const TARGETS: 'targets' = 'targets';
const TARGET_INSPECTOR: 'target_inspector' = 'target_inspector';
const ALERTS: 'alerts' = 'alerts';

export const SECTION = Object.freeze({
    options: OPTIONS,
    zones: ZONES,
    targets: TARGETS,
    targetInspector: TARGET_INSPECTOR,
    alerts: ALERTS
});

export const ZINDEX = {
    map: 0,
    zones: 5,
    trails: 10,
    targets: 15,
    labelConnectors: 16,
    draggableLabels: 17,
    drawing: 20
};

export const SET_SECTION: 'APP.SET_SECTION' = 'APP.SET_SECTION';
export const SET_TARGET: 'APP.SET_TARGET' = 'APP.SET_TARGET';
export const SET_TIS_ENABLED: 'APP.SET_TIS_ENABLED' = 'APP.SET_TIS_ENABLED';
export const SET_THROTTLING_INTERVAL: 'APP.SET_THROTTLING_INTERVAL' = 'APP.SET_THROTTLING_INTERVAL';

